import { Component, OnInit, inject } from '@angular/core';
import { Observable, takeUntil, tap } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomerClubDevicesService,
  OutBoxMessagesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import {
  CustomResultOfGetCustomerClubDeviceByIdDto,
  GetCustomerClubDeviceByIdDto,
  GetCustomerClubDeviceWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfGetCustomerClubDeviceWithPaginationDto,
} from '../../../core/api/models';
import { ChangeStatusFormComponent } from '../../setting/api-token/change-status-form/change-status-form.component';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { CustomerClubDeviceNumbersComponent } from './customer-club-device-numbers/customer-club-device-numbers.component';
import { CustomerClubDevicesDetailsComponent } from './customer-club-devices-details/customer-club-devices-details.component';
import { CustomerClubDevicesFormComponent } from './customer-club-devices-form/customer-club-devices-form.component';

@Component({
  selector: 'app-customer-club-devices',
  templateUrl: './customer-club-devices.component.html',
  imports: [
    BaseIndexModule,
    SmsBodyModule,
    CustomerClubDevicesFormComponent,
    CustomerClubDevicesDetailsComponent,
    CustomerClubDeviceNumbersComponent,
  ],
})

export class CustomerClubDevicesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.customerClubDevice;
  protected currentService = inject(CustomerClubDevicesService);
  paginationApiMethodName: string =
    this.currentService.customerClubDevicesGetCustomerClubDeviceWithPagination
      .name;
  createGetApiMethodName: string =
    this.currentService.customerClubDevicesCreateGet.name;
  auditApiMethodName: string =
    this.currentService
      .customerClubDevicesGetCustomerClubDeviceAuditWithPagination.name;
  modelWithPagination$: Observable<PaginatedListOfGetCustomerClubDeviceWithPaginationDto>;
  items$: Observable<Array<GetCustomerClubDeviceWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};
  detailModel: GetCustomerClubDeviceByIdDto = {};

  organizationId;
  userId;
  isShowDetail: boolean = false;
  isShowDeviceNumbers: boolean = false;
  customerClubDeviceId: number;

  OtpStatusEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(public outBoxMessagesService: OutBoxMessagesService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('OtpStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.OtpStatusEnumValues = values));
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Details_key:
          this.onGetDetailById(
            +value.toString().split('_')[0],
            +value.toString().split('_')[1],
            false
          );
          break;
      }
    }
  }
  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}deviceId`,
        name: 'deviceId',
        hasSearch: true,
      },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}webhookUrl`,
        name: 'webhookUrl',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}phonebookIdList`,
        name: 'phonebookIdList',
        noSorting: true,
        wrap: true,
      },
      {
        title: 'common.status',
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'OtpStatus',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .customerClubDevicesUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //get details
  getDetailByIdApi(id: number) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .customerClubDevicesUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe((items: CustomResultOfGetCustomerClubDeviceByIdDto) => {
        try {
          this.detailModel = items.data;
          this.isShowDetail = true;
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.facility);
        }
      });
  }

  onShowChangeStatus(id, status) {
    try {
      this.unSubs();

      let data = {
        title: 'common.changeStatusTo',
        isEdit: true,
        model: {
          id: id,
          status: status,
        },
        currentService: this.currentService,
        methodName:
          this.currentService.customerClubDevicesChangeCustomerClubDeviceStatus
            .name,
      };

      const modalResult = this.dialogService.openModal({
        component: ChangeStatusFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;
    this.currentService
      .customerClubDevicesDeleteDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onGetDetailById(id, organizationId, setUrl = true) {
    organizationId = +organizationId;
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id +
          '_' +
          organizationId
      );
    }
    this.organizationId = organizationId;
    this.getDetailByIdApi(id);
  }

  onDeviceNumbers(id) {
    this.customerClubDeviceId = id;
    this.isShowDeviceNumbers = true;
  }
}
